import format from 'date-fns/format';
import React from 'react';
import { usePermission } from '../../../../hooks/usePermission';

const ContentListItem = ({
  title,
  building_title,
  created,
  company,
  status,
  actions,
}: any = {}) => {
  const { isEditable } = usePermission();
  return (
    <li className="border-b border-neutral-100 flex flex-row items-center py-2 text-sm justify-between last:border-b-0 hover:bg-neutral-25/50 -mx-2 px-2 rounded transition-colors">
      <span className="flex-1 text-neutral-900 text-sm truncate">{title || ''}</span>
      <span className="flex-1 text-neutral-600 text-sm truncate">{building_title || ''}</span>
      <span className="flex-1 text-neutral-500 text-sm font-mono tabular-nums">
        {created ? format(new Date(created), 'dd. MM. yyyy') : ''}
      </span>
      <span className="flex-1 text-neutral-500 text-sm truncate">{company?.title || ''}</span>
      <span className="text-neutral-500 text-sm truncate">{status || ''}</span>
      {isEditable && (
        <span className="flex flex-row shrink-0 ml-2">
          {actions.map((ele, i) => (
            <div key={i} className="h-7 w-7 flex items-center justify-center">
              {ele}
            </div>
          ))}
        </span>
      )}
    </li>
  );
};

const EtapeList = ({ data, actions }) => {
  const icons = (id) =>
    (actions || []).map((item, i) => (
      <div key={i} className="actions-icon">
        {item(id)}
      </div>
    ));

  if (!data) return null;

  return (
    <ul className="pl-0 list-none">
      {data.map((ele, i) => ele && <ContentListItem key={i} {...ele} actions={icons(ele.id)} />)}
    </ul>
  );
};

export default EtapeList;
